import React from "react";
import "./Whitepaper.css";

function Whitepaper() {
  return (
    <div className="container">
      <h1>Big Lipped Fish Whitepaper</h1>
      <p>
        In oceans deep where waters flow,
        <br />
        Lives a fish with lips aglow.
        <br />
        Big and bright, they shine with bliss,
        <br />
        This fish just loves to give a kiss.
      </p>

      <p>
        Through coral reefs and seaweed green,
        <br />
        Its puckered lips are always seen.
        <br />
        With every fish and shell it meets,
        <br />
        It spreads its love through kisses sweet.
      </p>

      <p>
        In waves it dances, pure delight,
        <br />
        Its kisses bring the ocean light.
        <br />
        A memecoin born from ocean’s cheer,
        <br />
        Big Lipped Fish is finally here.
      </p>

      <p>
        So join the fun, dive right in,
        <br />
        Let Big Lipped Fish bring you a grin.
        <br />
        A kiss, a coin, a love so true,
        <br />
        Big Lipped Fish is here for you.
      </p>

      <img
        id="bigLippedFish"
        src="feesh-transparent.png"
        alt="Big Lipped Feesh"
      />

      <div className="disclaimer">
        <p>
          This should not be construed as financial advice or a solicitation for
          an investment. Big Lip feesh is a fun, meme project. Always do your
          own research before engaging with cryptocurrencies.
        </p>
      </div>
    </div>
  );
}

export default Whitepaper;
